import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS, IMAGES } from "../data/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="process"
      ref={ref}
      className="relative overflow-hidden py-28 sm:py-40 px-6 sm:px-10 md:px-16 grain"
      data-testid="process"
    >
      <motion.div style={{ y: bgY }} className="absolute inset-0 -z-0 scale-110">
        <img src={IMAGES.altar} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#21070D]/82" />
      </motion.div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <Eyebrow className="text-[#EBD08A]">Process</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif font-medium text-[#F4EBD9] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
              Your Session, Step by Step
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 italic font-serif text-lg sm:text-xl text-[#F4EBD9]/75">
              You do not need to have everything figured out. Come with your
              questions, your current situation, and an open mind.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
          {PROCESS.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
              className="relative"
            >
              <span className="text-gold-grad font-serif text-7xl sm:text-8xl leading-none">
                {step.n}
              </span>
              <h3 className="mt-3 font-serif text-2xl text-[#F4EBD9]">
                {step.title}
              </h3>
              <p className="mt-3 text-[#F4EBD9]/75 text-base leading-relaxed body-serif">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
